<template>
    <div class="feature-app-landing drak-area section-space--ptb_60" id="about">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-6 wow move-up">
                    <div class="feature-app-landing__wrap">
                        <div class="feature-app-landing__inner ">
                            <div class="section-title">
                                <h2>A Collection of Prominent Features</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 wow move-up">
                    <div class="feature-app-landing__wrap">
                        <div class="feature-app-landing__inner">
                            <div class="feature-app-landing__icon">
                                <div class="icon">
                                    <i class="fa fa-bell"></i>
                                </div>
                            </div>
                            <div class="feature-app-landing__content">
                                <h5 class="heading mb-10">Share Your Moments</h5>
                                <div class="text">Capture and upload photos, videos, and reviews of your favorite foods, movies, and games</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 wow move-up">
                    <div class="feature-app-landing__wrap">
                        <div class="feature-app-landing__inner">
                            <div class="feature-app-landing__icon">
                                <div class="icon">
                                    <i class="fa fa-rocket"></i>
                                </div>
                            </div>
                            <div class="feature-app-landing__content">
                                <h5 class="heading mb-10">Discover New Experiences</h5>
                                <div class="text">Find personalized recommendations based on your location and interests.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 wow move-up">
                    <div class="feature-app-landing__wrap">
                        <div class="feature-app-landing__inner">
                            <div class="feature-app-landing__icon">
                                <div class="icon">
                                    <i class="fa fa-arrow-alt-to-bottom"></i>
                                </div>
                            </div>
                            <div class="feature-app-landing__content">
                                <h5 class="heading mb-10">Interactive Map</h5>

                                <div class="text">Easily locate and explore experiences around you with our intuitive map feature.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 wow move-up">
                    <div class="feature-app-landing__wrap">
                        <div class="feature-app-landing__inner">
                            <div class="feature-app-landing__icon">
                                <div class="icon">
                                    <i class="fa fa-bolt"></i>
                                </div>
                            </div>
                            <div class="feature-app-landing__content">
                                <h5 class="heading mb-10">Community Engagement</h5>

                                <div class="text">Follow, comment, and like posts from other users to connect with people who share your interests.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 wow move-up">
                    <div class="feature-app-landing__wrap">
                        <div class="feature-app-landing__inner">
                            <div class="feature-app-landing__icon">
                                <div class="icon">
                                    <i class="fa fa-mobile-alt"></i>
                                </div>
                            </div>
                            <div class="feature-app-landing__content">
                                <h5 class="heading mb-10">Personalized Feeds </h5>

                                <div class="text">Enjoy tailored suggestions and updates about what's trending near you.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: '',
    };
</script>

<style lang="scss">

</style>